module.exports = __webpack_public_path__ + "static/assets/9801a0954cd21b2bd0b987865ac07286.svg";